import { Component } from 'react';
import * as React from 'react';
import { reportError } from 'automation-ui-core/errors/utils/reportError';
import ErrorMessage from 'automation-ui-canvas/components/errors/ErrorMessage';

/**
 * Usage:
 *   <ErrorBoundary boundaryName="MyComponent_MyError" renderError={() => <MyError />}}>
 *     <MyComponent />
 *   </ErrorBoundary>
 */
import { jsx as _jsx } from "react/jsx-runtime";
class ErrorBoundary extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      caughtError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      caughtError: true
    };
  }
  componentDidCatch(error, info) {
    const {
      boundaryName
    } = this.props;
    error.info = JSON.stringify(info);
    reportError({
      error,
      tags: {
        errorBoundaryName: boundaryName
      }
    });
    this.setState({
      caughtError: error
    });
  }
  render() {
    const {
      children,
      renderError
    } = this.props;
    const {
      caughtError
    } = this.state;
    if (caughtError) {
      return renderError(caughtError);
    }
    return children;
  }
}
ErrorBoundary.defaultProps = {
  renderError: () => /*#__PURE__*/_jsx(ErrorMessage, {}),
  boundaryName: ''
};
export default ErrorBoundary;